import { Injectable } from '@angular/core';
import {
  DesignPage,
  DesignPageMediaItem,
  DesignSpread,
  DesignStructure,
} from '@gelato-api-ui/core/designs/design-structure';
import { DesignPageMediaItemType } from '@gelato-api-ui/core/designs/constants/design-structure.constant';
import { DesignEditorTabName } from '@gelato-api-ui/core/design-editor/types/design-editor-tab-name.enum';
import { Design } from '@gelato-api-ui/core/designs/design';

@Injectable()
export class DesignStructureService {
  getAvailableSidebarTabs(designStructure: DesignStructure): DesignEditorTabName[] {
    const showProductTab = this.isCanvas(designStructure) || this.isCalendar(designStructure);
    const tabs = [];

    if (showProductTab) {
      tabs.push(DesignEditorTabName.PRODUCT);
    }

    if (this.hasPersonalizableMediaItems(designStructure, DesignPageMediaItemType.IMAGE)) {
      tabs.push(DesignEditorTabName.GALLERY);
    }

    if (tabs.length) {
      tabs.push(DesignEditorTabName.WARNINGS);
    }

    return tabs;
  }

  isCalendar(designStructure: DesignStructure): boolean {
    return /calendar/.test(designStructure?.product_uid);
  }

  isCanvas(designStructure: DesignStructure): boolean {
    return /^canvas/.test(designStructure?.product_uid);
  }

  isApparel(designStructure: DesignStructure): boolean {
    return /^apparel/.test(designStructure?.product_uid);
  }

  private hasPersonalizableMediaItems(
    designStructure: DesignStructure,
    mediaItemType: DesignPageMediaItemType,
  ): boolean {
    if (!designStructure?.spreads?.length) {
      return false;
    }

    return designStructure.spreads.some((loopSpread: DesignSpread): boolean => {
      if (!loopSpread?.pages?.length) {
        return false;
      }

      return loopSpread?.pages?.some((loopPage: DesignPage): boolean => {
        if (!loopPage?.groups?.media?.length) {
          return false;
        }

        const matchingMediaItem = loopPage?.groups?.media.find(
          (loopMediaItem: DesignPageMediaItem): boolean =>
            loopMediaItem?.type === mediaItemType && !loopMediaItem?.personalizationLocked,
        );

        return Boolean(matchingMediaItem);
      });
    });
  }

  getUsedPlugins(design: Design): string[] {
    if (!design?.structure) {
      return null;
    }

    const parsedDesignStructure: DesignStructure = JSON.parse(design.structure);

    const mediaPlugins = [];
    const generalPlugins = parsedDesignStructure?.plugins || [];
    parsedDesignStructure.spreads
      .filter(spread => spread.pages?.length)
      .forEach(spread => {
        spread.pages.forEach(page => {
          page?.groups?.media?.forEach(media => {
            if (media?.plugins?.length) {
              mediaPlugins.push(...Object.keys(media.plugins));
            }
          });
        });
      });

    return [...generalPlugins, ...mediaPlugins];
  }
}
